/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Status_FailedInputs */

const en_admin_payments_status_failed = /** @type {(inputs: Admin_Payments_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Admin_Payments_Status_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_status_failed = /** @type {((inputs?: Admin_Payments_Status_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Status_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_status_failed(inputs)
});
export { admin_payments_status_failed as "admin.payments.status_failed" }